import React, { Fragment } from 'react';

// const sameCategory = (item, index, array) =>
//     (index > 0 && array[index-1].category) === (array[index].category || item.showAll);

// ${selectedItem === index ? 'quick-search-result__item--selected' : ''}`

const QuickSearchResult = ({ result, selectedItem, searchUrl }) => (
    result && (
        <div className="quick-search-result">
            <div className="quick-search-result-wrapper">
            {result.map((resultRow) => (
                <Fragment key={resultRow.category}>
                    {resultRow.category !== 'ShowAll' && (
                        <div className="row columns">
                            <h2 className="columns small-12 quick-search-result__header">
                                {resultRow.category}
                            </h2>
                        </div>
                    )}
                    <ul className="row product-list">
                        {resultRow.items.map(({ imageSource, hasImage, showAll, name, articleNumber, url }) => (
                            <li className={`columns ${
                                showAll ? 'small-12 quick-search-result__show-all-column' : 'product-list__item small-6 medium-4 large-2'
                                }`} key={imageSource}>
                                {((hasImage && imageSource) || !showAll) ? (
                                    <Fragment>
                                        <figure className="quick-search-result__image">
                                            <a href={url} title={name}>
                                                <img className="product__image" itemProp="image" src={imageSource} />
                                            </a>                                        </figure>
                                        <article className="product__info">
                                            <a href={url} title={name}>
                                                <h3 itemProp="name" className="product__name">{name}</h3>
                                                <h3 itemProp="articleNumber" className="product__name">{articleNumber}</h3>
                                            </a>
                                        </article>
                                    </Fragment>
                                ) : (
                                        <a href={searchUrl} className={showAll ? `quick-search-result__show-all ${result.length > 1 ? '' : 'quick-search-result__link--disabled'}` : `quick-search-result__link ${result.length > 1 ? '' : 'quick-search-result__link--disabled'}`}>
                                            <span>{articleNumber}</span>
                                            &nbsp;
                                            <span>{name}</span>
                                        </a>
                                    )}
                            </li>
                        ))}
                    </ul>
                </Fragment>
            ))}

            </div>
        </div>
    )
)

export default QuickSearchResult;